module.exports = __webpack_public_path__ + "static/media/insert_shape_passo3.0aa87d43.png";